import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Tab, Typography } from '@mui/material';
import { NoAvailableCard } from 'common';
import * as R from 'ramda';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ConfirmationPage from './ConfirmationPage';
import InventorySummaryTab from '../inventorySummary/InventorySummaryTab';

const Confirmation = ({
  toLocations,
  reconsignmentState,
  createReconsignmentInventoryDetails,
  createReconsignmentResults,
}) => {
  const [tab, setTab] = useState('confirmation');

  const [confirmationRows, setConfirmationRows] = useState([]);

  const renderConfirmation = R.cond([
    [R.isEmpty, R.always(<NoAvailableCard type="reconsignments" />)],
    [
      R.T,
      R.always(
        <ConfirmationPage
          createReconsignmentResults={createReconsignmentResults}
          gridRows={confirmationRows}
          reconsignmentState={reconsignmentState}
          setGridRows={setConfirmationRows}
          toLocations={toLocations}
        />
      ),
    ],
  ]);
  const renderInventorySummary = R.cond([
    [R.isEmpty, R.always(<NoAvailableCard type="reconsignments" />)],
    [
      R.T,
      R.always(
        <InventorySummaryTab
          createReconsignmentInventoryDetails={createReconsignmentInventoryDetails}
          createReconsignmentResults={createReconsignmentResults}
          reconsignmentState={reconsignmentState}
          toLocations={toLocations}
        />
      ),
    ],
  ]);

  return (
    <Box sx={{ p: 3, pt: 8 }}>
      <Box display="flex" flexDirection="column" gap={1}>
        <Typography
          sx={{
            flexWrap: 'nowrap',
            fontFamily: 'Overpass',
            fontSize: '24px',
            fontWeight: 400,
            lineHeight: 'normal',
            whiteSpace: 'nowrap',
          }}
          variant="h5"
        >
          Your Reconsignment Was Successfully Submitted!
        </Typography>
        <Typography
          color="textSecondary"
          sx={{
            flexWrap: 'nowrap',
            fontFamily: 'Gothic A1',
            fontSize: '12.5px',
            fontWeight: 600,
            letterSpacing: '0.4px',
            lineHeight: '16px',
            whiteSpace: 'nowrap',
          }}
          variant="body2"
        >
          Reconsignment was created for {reconsignmentState?.inventoryOwner?.customerNameShort}.
        </Typography>
      </Box>
      <Box sx={{ mb: 3, mt: 1 }}>
        <TabContext value={tab}>
          <Box
            sx={{
              backgroundColor: 'surface.light',
              left: 0,
              overflow: 'hidden',
              width: '100%',
              zIndex: 1,
            }}
          >
            <Box
              sx={{
                backgroundColor: 'surface.light',
                borderBottom: 1,
                borderColor: 'divider',
                bottom: 0,
                boxShadow: { lg: 'none', xs: 1 },
                left: 0,
                mt: { lg: 1, xs: 1 },
                position: { lg: 'relative', xs: 'fixed' },
                width: 1,
                zIndex: 1,
              }}
            >
              <TabList
                onChange={(_, val) => {
                  setTab(val);
                  window.scrollTo(0, 0);
                }}
                sx={{
                  width: 250,
                }}
              >
                <Tab
                  label="Confirmation"
                  sx={{ minWidth: 20, px: 0, py: 1 }}
                  value="confirmation"
                />
                <Tab
                  label="Inventory Summary"
                  sx={{ minWidth: 20, px: 0, py: 1 }}
                  value="inventorySummary"
                />
              </TabList>
            </Box>
          </Box>
          <TabPanel sx={{ pb: 0.5, position: 'relative', px: 0 }} value="confirmation">
            {renderConfirmation(['data'])}
          </TabPanel>
          <TabPanel sx={{ pb: 0.5, position: 'relative', px: 0 }} value="inventorySummary">
            {renderInventorySummary(['data'])}
          </TabPanel>
        </TabContext>
      </Box>
    </Box>
  );
};
Confirmation.propTypes = {
  createReconsignmentInventoryDetails: PropTypes.shape([]).isRequired,
  createReconsignmentResults: PropTypes.shape([]).isRequired,
  reconsignmentState: PropTypes.shape({
    inventoryOwner: PropTypes.shape({
      customerNameShort: PropTypes.string,
    }),
  }).isRequired,
  toLocations: PropTypes.shape([]).isRequired,
};

export default Confirmation;
